module.exports = require("babel-runtime/core-js/object/values");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/core-js/object/values"
// module id = 31
// module chunks = 0